/**
 * JotAuditPageWrapper Component
 *
 * Conditionally renders either the full JotAuditPage or the "coming soon" AuditPage
 * based on the payer_template_note_processing feature flag
 */

import React from 'react';
import { AuditPage } from '@features/jotcoach';
import { useFeatureFlag } from '@features/user';

import { JotAuditPage } from './JotAuditPage';

export const JotAuditPageWrapper: React.FC = () => {
  const isPayerTemplateProcessingEnabled = useFeatureFlag('payer_template_note_processing');

  if (isPayerTemplateProcessingEnabled) {
    return <JotAuditPage />;
  }

  return <AuditPage />;
};

export default JotAuditPageWrapper;
